import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "@env/environment";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";

declare var Stimulsoft: any;

@Component({
  selector: "kl-report-viewer",
  templateUrl: "./kl-report-viewer.component.html",
  styleUrls: ["./kl-report-viewer.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class KlReportViewerComponent implements OnInit {
  viewer: any;
  report: any = new Stimulsoft.Report.StiReport();

  static get apiUrl() {
    return (
      (localStorage.getItem("apiUrl")
        ? localStorage.getItem("apiUrl")
        : environment.apiUrl) + "/"
    );
  }

  currentReport: any;

  constructor(
    private http: HttpClient,
    private translateService: TranslateService
  ) {
    const localLanguage = localStorage.getItem("currentLanguage");
    translateService.use(localLanguage);
  }

  ngOnInit() {
    const newWindow: any = window;
    if (newWindow.currentReport) {
      const options = new Stimulsoft.Viewer.StiViewerOptions();
      options.appearance.scrollbarsMode = true;
      options.appearance.pageBorderColor = Stimulsoft.System.Drawing.Color.navy;
      options.toolbar.borderColor = Stimulsoft.System.Drawing.Color.navy;
      options.toolbar.showPrintButton = true;
      options.toolbar.showViewModeButton = true;
      options.toolbar.viewMode = Stimulsoft.Viewer.StiWebViewMode.SinglePage;
      options.toolbar.zoom = 100;
      options.height = "100vh";
      this.viewer = new Stimulsoft.Viewer.StiViewer(
        options,
        "StiViewer",
        false
      );
      if (newWindow.viewerData) {
        this.report.load(newWindow.currentReport.content);
        const dataSet = new Stimulsoft.System.Data.DataSet("JSON");
        // Object.keys(newWindow.viewerData).forEach((objectKey: any) => {
        //     if  (typeof objectKey === 'object') {
        //     } else {
        //         newWindow.viewerData[objectKey].forEach(field => {
        //             if (newWindow.translateFields) {
        //                 if (newWindow.translateFields.length > 0) {
        //                     newWindow.translateFields.forEach(key => {
        //                         field[key] = this.translateService.instant(field[key]);
        //                     });
        //                 }
        //             }
        //             if (newWindow.dateFields) {
        //                 if (newWindow.dateFields.length > 0) {
        //                     newWindow.dateFields.forEach(key => {
        //                         field[key] = new Date(field[key]);
        //                     });
        //                 }
        //             }
        //         });
        //     }
        // });
        dataSet.readJson(newWindow.viewerData);
        this.report.regData("JSON", "JSON", dataSet);
        this.viewer.report = this.report;
        this.viewer.renderHtml("viewer");
      } else {
        this.http
          .post(
            KlReportViewerComponent.apiUrl + KlReportViewerComponent.apiUrl,
            newWindow.filter,
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
              },
            }
          )
          .subscribe((data: any) => {
            this.report.load(newWindow.currentReport.content);
            const dataSet = new Stimulsoft.System.Data.DataSet("JSON");
            if (data.data.report_fields.length > 0) {
              data.data.report_fields.forEach((field) => {
                if (newWindow.translateFields) {
                  if (newWindow.translateFields.length > 0) {
                    newWindow.translateFields.forEach((key) => {
                      field[key] = this.translateService.instant(field[key]);
                    });
                  }
                }
                if (newWindow.dateFields) {
                  if (newWindow.dateFields.length > 0) {
                    newWindow.dateFields.forEach((key) => {
                      field[key] = new Date(field[key]);
                    });
                  }
                }
              });
            }
            dataSet.readJson(data.data);
            this.report.regData("JSON", "JSON", dataSet);
            this.viewer.report = this.report;
            this.viewer.renderHtml("viewer");
          });
      }
    } else {
      newWindow.close();
    }
  }
}
